import associatedParties from './associatedPartiesSaga';
import orgAccess from './orgAccessSaga'
import notification from "./notification";
import globalSearch from "./globalSearchSaga";
import header from "./headerSaga";
import manageProfile from "./manageProfileSaga";
import sessionContextOidc from "./sessionContextOidcSaga";
import navigation from "./navigationSaga";

const array = [].concat(associatedParties, orgAccess, notification, globalSearch, header, manageProfile, sessionContextOidc, navigation);

export default  array;